import React, { useState } from "react";
import { DataTable } from "./DataTable";
import { Button } from "antd";
import { YhBox } from "@/components/YhBox";
import { ResourceAuthEnum } from "@/types/FmsResourceAuthEnum";
import { YhAuth } from "@/components/auth/YhAuth";
import { usePaymentModel } from "../paymentModel";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";


export const DataBox = () => {
    const { exportApi, exportLoading, statistics } = usePaymentModel();

    const action = <>
        {/* <YhAuth resCode={ResourceAuthEnum.ST_STOCK_EX}> */}
        <Button
            className="mr-5"
            type="link"
            shape="round"
            loading={exportLoading}
            onClick={() => exportApi()}
        >导出</Button>
        {/* </YhAuth > */}
    </>;

    const desc: IDescription[] = [
        {
            label: "差异金额",
            value: statistics?.diffAmount.toFixed(2) ?? '0.00',
            color: DescriptionColorEnum.red
        },

    ]

    return (
        <YhBox title={action} descriptions={desc}>
            <DataTable />
        </YhBox>
    )
}